import PropTypes from 'prop-types';
import React from 'react';

import Label from './Label';
import LeftRightSplit from './LeftRightSplit';


function LabeledControl({
  bold = false,
  label,
  labelSize = '50%',
  control,
  alignRight = false,
  reverse = false,
  underline = false,
  controlMarginLeft = undefined,
  red = false,
  blue = false,
  validationFor = undefined
}: {
  bold?: boolean,
  label: React.ReactNode|string,
  labelSize?: string,
  control: React.ReactNode|string,
  alignRight?: boolean,
  reverse?: boolean,
  underline?: boolean,
  controlMarginLeft?: string|undefined,
  red?: boolean,
  blue?: boolean,
  validationFor?:string|undefined,
}) {
  const labelProps = reverse
    ? ( alignRight ? { style: { textAlign: 'right' } } : { style: { paddingLeft: '5px' } } )
    : ( alignRight ? { style: { textAlign: 'right', paddingRight: '5px' } } : {} );
  
  const controlProps = !!controlMarginLeft
    ? { style: { paddingLeft: controlMarginLeft } }
    : {};
  
  if (reverse) {
    return (
      <LeftRightSplit
        right={<Label bold={bold} red={red} blue={blue} label={label} underline={underline} validationFor={validationFor} />}
        rightSize={labelSize}
        rightProps={labelProps}
        leftSize={`calc(100% - ${labelSize})`}
        left={control}
        leftProps={controlProps}
      />
    );
  } else {
    return (
      <LeftRightSplit
        left={<Label bold={bold} red={red} blue={blue} label={label} underline={underline} validationFor={validationFor} />}
        leftSize={labelSize}
        leftProps={labelProps}
        rightSize={`calc(100% - ${labelSize})`}
        right={control}
        rightProps={controlProps}
      />
    );
  }
}

LabeledControl.defaultProps = {
  label: '',
  labelSize: '50%',
  alignRight: false,
  bold: false,
  reverse: false,
  underline: false,
  red: false,
  blue: false
};

LabeledControl.propTypes = {
  underline: PropTypes.bool.isRequired,
  alignRight: PropTypes.bool.isRequired,
  bold: PropTypes.bool.isRequired,
  reverse: PropTypes.bool.isRequired,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  labelSize: PropTypes.string.isRequired,
  control: PropTypes.node,
  controlMarginLeft: PropTypes.string,
  validationFor: PropTypes.string,
  red: PropTypes.bool.isRequired,
  blue: PropTypes.bool.isRequired,
};


export default React.memo(LabeledControl);
